<template>
    <div>
        <masternav/>
        <div class="image-banner">
            <img src="https://www.enterprisepanama.com/img/imagenes_standard_of_care/generic-standard-of-care-640x360-green.png" class="responsive-img my-4" alt="">
        </div>
        <div class="content">
          <p class="titlepromo">{{$t('main_content.title_covid')}}</p>
          <p class="textpromo">{{ $t("stardard.text_1") }}</p>
          <p class="textpromo">{{ $t("stardard.text_2") }} </p>
          <p class="textpromo">{{ $t("stardard.text_3") }} </p>
          <p class="textpromo">{{ $t("stardard.text_4") }}</p>
          <div class="row mt-5 mb-4">
            <div class="col-md-3 text-right">
              <img width="190px" src="https://www.enterprisepanama.com/img/imagenes_standard_of_care/enterprise-complete-clean-pledge-550x550-canvas.png"></img>
            </div>
            <div class="col-md-9">
              <p class="titlepromo">{{ $t("stardard.text_5") }}</p>
              <p class="textpromo">{{ $t("stardard.text_6") }} </p>
            </div>
          </div>

          <!-- <div class="row mb-4">
            <div class="col-md-3 text-right">
              <img width="190px" src="https://www.enterprisepanama.com/img/imagenes_standard_of_care/enterprise-standard-of-care-icons-clorox-550x500-canvas2.png"></img>
            </div>
            <div class="col-md-9">
              <p class="titlepromo">{{ $t("stardard.text_7") }}</p>
              <p class="textpromo">{{ $t("stardard.text_8") }}</p>
            </div>
          </div> -->

          <div class="row mb-4">
            <div class="col-md-3 text-right">
              <img width="190px" src="https://www.enterprisepanama.com/img/imagenes_standard_of_care/enterprise-standard-of-care-icons-low-touch-transactions-550x550-canvas.png"></img>
            </div>
            <div class="col-md-9">
              <p class="titlepromo">{{ $t("stardard.text_9") }}</p>
              <p class="textpromo">{{ $t("stardard.text_10") }}</p>
            </div>
          </div>

          <div class="row mb-4">
            <div class="col-md-3 text-right">
              <img width="190px" src="https://www.enterprisepanama.com/img/imagenes_standard_of_care/enterprise-standard-of-care-icons-exceptional-customer-service-550x550-canvas.png"></img>
            </div>
            <div class="col-md-9">
              <p class="titlepromo">{{ $t("stardard.text_11") }}</p>
              <p class="textpromo">{{ $t("stardard.text_12") }}</p>
            </div>
          </div>

          <div class="row mb-4">
            <div class="col-md-3 text-right">
              <img width="190px" src="https://www.enterprisepanama.com/img/imagenes_standard_of_care/enterprise-standard-of-care-icons-fully-maintained-vehicles-550x500-canvas.png"></img>
            </div>
            <div class="col-md-9">
              <p class="titlepromo">{{ $t("stardard.text_13") }}</p>
              <p class="textpromo">{{ $t("stardard.text_14") }}</p>
            </div>
          </div>

          <div class="row mb-4">
            <div class="col-md-3 text-right">
              <img width="190px" src="https://www.enterprisepanama.com/img/imagenes_standard_of_care/enterprise-standard-of-care-icons-visual-inspection-550x550-canvas.png"></img>
            </div>
            <div class="col-md-9">
              <p class="titlepromo">{{ $t("stardard.text_15") }}</p>
              <p class="textpromo">{{ $t("stardard.text_16") }}</p>
            </div>
          </div>
        </div>
        <!--
            <covidnews/>
            <hr>
            <contactcomp/>
        -->
        <mainfooter/>
    </div>
</template>

<script>
import masternav      from '@/components/masternav.vue'
import maincontent    from '@/components/maincontent.vue'
import mainfooter     from '@/components/mainfooter.vue'
import rents          from '@/components/rents.vue'
import covidnews      from '@/components/covidnews.vue'
import contactcomp    from '@/components/contactcomp.vue'

export default {
    name: 'Covid19',
    components: {
        masternav,
        mainfooter,
        maincontent,
        rents,
        covidnews,
        contactcomp
    }
}
</script>

<style>
@media only screen and (max-width: 769px) {

    .image-banner {
        text-align: center;
    }

    .responsive-img {
        width: 100%;
        height: auto;
    }
}

@media only screen and (min-width: 769px) {

    .image-banner {
        text-align: center;
        background-color: #169a5a;
    }

    .responsive-img {
        width: 30%;
        height: auto;
    }

}

.titlepromo {
    font-family: 'DIN 2014-Regular', Arial, sans-serif;
    font-size: 30px;
    font-weight: bold;
}

.textpromo {
    font-family: 'DIN 2014-Regular', Arial, sans-serif;
    font-size: 17px;
    font-weight: 400;
}

.content {

    margin: 50px 0 50px 0;
    padding: 0 15% 0 15%;

}
</style>